export const opsZoneDetails = {
  currentOpsZone: {
    city: null as string | null,
    country: null as string | null,
    holidays: [] as any[],
    maxNumberOfDaysForFutureBooking: null as number | null,
    minTimeBeforeBooking: null as number | null,
    onBoardPaymentAllowed: null as boolean | null,
    opsRegionId: null as string | null,
    opsZoneId: null as string | null,
    opsZoneArea: null as unknown,
    opsZoneName: null as string | null,
    opsZoneRestrictionAreas: null as unknown,
    pointOfInterestIds: null as unknown,
    serviceShortName: null as string | null,
    shuttleType: null as unknown,
    stopWaitingTime: null as unknown,
    vehicleCategories: null as any[] | null,
    zoneWeekDays: null as any[] | null,
    timeZone: null as string | null,
    // mocked
    allowOnDemandPickUpTime: null as boolean | null,
    isFreeTrip: false,
  },
};

export type OpsZoneState = typeof opsZoneDetails;
